import { list as getList } from "~/api/contractBackupDatabase";
import * as types from "../mutation-types";
import store from "../../store";
import { entityStoreStatus } from "~/mixins/entityStoreStatus";

export const state = {
  list: null,
  isInitialLoadPending: true,
  isLoading: false
};

/**
 * Mutations
 */
export const mutations = {
  [types.SET_IS_LOADING_CONTRACT_BACKUP_DATABASE](state, status) {
    state.isLoading = status;
  },
  [types.SET_CONTRACT_BACKUP_DATABASE](state, contractStorage) {
    state.list = contractStorage.data;
    state.isInitialLoadPending = false;
  }
};

/**
 * Actions
 */
export const actions = {
  fetchContractBackupDatabase({ commit }, contractId = null) {
    commit(types.SET_IS_LOADING_CONTRACT_BACKUP_DATABASE, true);

    let activeContractId =
      contractId || store.getters["contract/activeContract"]?.id;

    if (activeContractId) {
      getList(activeContractId).then((response) => {
        let { data } = response;
        commit(types.SET_CONTRACT_BACKUP_DATABASE, data);
        commit(types.SET_IS_LOADING_CONTRACT_BACKUP_DATABASE, false);
      });
    }
  }
};

/**
 * Getters
 */
export const getters = {
  list: (state) => state.list,
  isLoading: (state) => state.isLoading,
  isInitialLoadPending: (state) => state.isInitialLoadPending,
  ...entityStoreStatus.getters
};
